import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function PricingCard({ plan, index }) {
	const navigate = useNavigate();

	const handleGetStarted = () => {
		navigate('/contact-us');
	};

	return (
		<motion.div
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6, delay: index * 0.1 }}
			className="relative h-full"
		>
			{/* Recommended Badge */}
			{plan.recommended && (
				<div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
					<div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wide shadow-lg">
						Recommended
					</div>
				</div>
			)}

			<div
				className={`h-full flex flex-col bg-gradient-to-br from-purple-600/5 to-blue-600/5 backdrop-blur-xl rounded-2xl p-8 border ${
					plan.recommended 
						? 'border-purple-500/50 shadow-2xl shadow-purple-500/20' 
						: 'border-purple-500/20'
				} hover:border-purple-500/50 transition-all duration-300`}
			>
				{/* Tag */}
				{plan?.tag && (
					<div className="mb-4">
						<span className="text-sm font-medium uppercase tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400">
							{plan.tag}
						</span>
					</div>
				)}

				{/* Title */}
				<h2 className="text-white text-2xl font-bold mb-3 leading-snug">
					{plan.title}
				</h2>

				{/* Description */}
				<p className="text-gray-300 text-sm leading-relaxed mb-8">
					{plan.description}
				</p>

				{/* Get Started Button */}
				{/* <button 
					onClick={handleGetStarted}
					className={`w-full font-semibold py-3.5 px-6 rounded-lg transition-all duration-200 mb-8 shadow-md hover:shadow-lg active:scale-[0.98] ${
						plan.recommended
							? 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white'
							: 'bg-gradient-to-r from-purple-600/80 to-blue-600/80 hover:from-purple-600 hover:to-blue-600 text-white'
					}`}
				>
					{plan.buttonText || "Get Started"}
				</button> */}

				{/* Divider */}
				<div className="h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent mb-8" />

				{/* Features */}
				<div className="flex-grow">
					<h3 className="text-white font-bold mb-4 text-base">Features:</h3>
					<ul className="space-y-3">
						{plan.features.map((feature, idx) => (
							<li key={idx} className="flex items-start gap-3">
								<div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mt-0.5">
									<Check className="w-3 h-3 text-white" strokeWidth={3} />
								</div>
								<span className="text-gray-300 text-sm leading-relaxed">
									{feature}
								</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</motion.div>
	);
}